import { Box, Grid, IconButton, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTheme } from '@emotion/react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { showLoader } from '../../../../../Redux/Slices/loaderSlice';
import { addNotifications, getNotifications, } from '../../../../../Redux/Actions/action';
import ButtonContained from '../../../../Common/ButtonContained';
import CommonTable from '../../../../Common/CommonTable';
import StyledTableCell from '../../../../Common/styledTableCell';
import DataNotFound from '../../../../Common/DataNotFound';
import CustomPagination from '../../../../Common/CommonPagination';
import CustomDialog from '../../../../Common/CustomDialog';
import TextLabel from '../../../../Common/CommonTextLabel';
import CommonTextField from '../../../../Common/CommonTextField';
import ErrorHandler, { ReadMore } from '../../../../../Utils/handler';
import CommonDatePicker from '../../../../Common/CommonDatePicker';
import dayjs from 'dayjs';


const headerList = ["No", "Title", "Description", "Date"]
function Notification() {
    const theme = useTheme()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({
        title: "",
        description: "",
        date: dayjs()
    });
    const [notificationList, setNotificationList] = useState({});
    const [error, setError] = useState({});
    // const [isEdit, setIsEdit] = useState(false);
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const validation = () => {
        let isValid = true;
        let error = {}
        if (!data.title) {
            error.title = "Title is required";
            isValid = false;
        }
        if (!data.description) {
            error.description = "Descriptions is required";
            isValid = false;
        }
        if (!data.date) {
            error.date = "Date is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value?.trimStart() });
    };

    const handleDateChange = (name, value) => {
        handleInputChange({ target: { name, value: value?.toString() } });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 1));
        setPage(1);
    };

    const handleClear = () => {
        setOpen(false);
        // setIsEdit(false);
        setData({
            title: "",
            description: "",
            date: dayjs()
        });
        setError({})
    };

    const _createUpdateNotificatin = async () => {
        if (validation()) {
            dispatch(showLoader(true))
            try {
                let body = {
                    title: data?.title,
                    description: data?.description,
                    date: data?.date,
                }
                // if (isEdit && data?._id) {
                //     body._id = data?._id;
                // }
                // const fn = isEdit ? updateNotifications : addNotifications
                const result = await dispatch(addNotifications(body))
                const error = ErrorHandler(result)
                if (error) {
                    toast.success(result?.payload?.message);
                    _getNotification()
                    handleClear()
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false))
            }
        }
    }

    const _getNotification = async () => {
        dispatch(showLoader(true))
        let body = {
            page: page,
            limit: rowsPerPage
        }
        try {
            const result = await dispatch(getNotifications(body));
            const error = ErrorHandler(result);
            if (error) {
                // toast.success(result?.payload?.message);
                setNotificationList(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    // const _deleteNotification = async (id) => {
    //     dispatch(showLoader(true))
    //     try {
    //         const result = await dispatch(deleteNotifications(id));
    //         const error = ErrorHandler(result);
    //         if (error) {
    //             toast.success(result?.payload?.message);
    //             _getNotification()
    //         }
    //     } catch (error) {
    //         toast.error(error);
    //     } finally {
    //         dispatch(showLoader(false))
    //     }
    // }

    useEffect(() => {
        _getNotification()
    }, [page, rowsPerPage])


    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                        <ButtonContained text={'Add Notification'} onClick={() => setOpen(true)} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <CommonTable
                        headerList={headerList}
                        minWidth={400}
                    // sx={{ mt: 2 }}
                    >
                        {notificationList?.data?.length > 0 ? notificationList?.data?.map((value, index) => (
                            <TableRow key={value.id}>
                                <StyledTableCell align="center">{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                                <StyledTableCell align="center">{value?.title}</StyledTableCell>
                                <StyledTableCell align="center"><ReadMore content={value?.description} /></StyledTableCell>
                                <StyledTableCell align="center">{value?.date ? new Date(value?.date).toLocaleDateString() : 'N/A'} </StyledTableCell>
                                {/* <StyledTableCell align="center">
                                    <IconButton sx={{ padding: 0 }} onClick={() => {
                                        setOpen(true);
                                        setIsEdit(true);
                                        setData(value)
                                    }} >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <IconButton sx={{ padding: 0 }} onClick={() => {
                                        _deleteNotification(value?._id)
                                    }} >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </StyledTableCell> */}
                            </TableRow>
                        )) :
                            (
                                <TableRow>
                                    <StyledTableCell colSpan={8}>
                                        <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                    </StyledTableCell>
                                </TableRow>
                            )
                        }
                    </CommonTable>
                    {notificationList?.count > 0 &&
                        <Grid item xs={12}>
                            <CustomPagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                count={Math.ceil(notificationList?.count / rowsPerPage)}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage} />

                        </Grid>
                    }
                </Grid>
                {
                    open && <CustomDialog
                        isOpen={open} handleClose={handleClear} title={'Add Notification'} padding={'10px'}
                        width={400}
                        action={
                            <>
                                <ButtonContained
                                    text={'Add Notification'}
                                    onClick={() => {
                                        _createUpdateNotificatin()
                                    }}
                                    minWidth={'100%'}
                                    marginTop={'10px'}

                                />
                            </>
                        }
                    >
                        <Grid container spacing={2} xs={12} ml={-1}>
                            <Grid item xs={12}>
                                <CommonTextField
                                    value={data?.title}
                                    width={"100%"}
                                    text="Title"
                                    type="text"
                                    onChange={(e) => handleInputChange(e)}
                                    placeholder="Enter a Title"
                                    name="title"
                                    valid
                                />
                                <TextLabel
                                    title={!data?.title ? error?.title : ""}
                                    color="error"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CommonTextField
                                    value={data?.description}
                                    width={"100%"}
                                    text="Description"
                                    type="text"
                                    onChange={(e) => handleInputChange(e)}
                                    placeholder="Enter a Description"
                                    name="description"
                                    valid
                                />
                                <TextLabel
                                    title={!data?.description ? error?.description : ""}
                                    color="error"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CommonDatePicker
                                    name={"date"}
                                    label={"Date"}
                                    labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                                    onChange={(value) => handleDateChange("date", value)}
                                    maxDate={dayjs()}
                                    value={data?.date}
                                    // height={30}
                                    valid
                                />
                                <TextLabel
                                    title={!data?.date ? error?.date : ""}
                                    color="error"
                                />
                            </Grid>
                        </Grid>
                    </CustomDialog>
                }
            </Grid>
        </>
    )
}

export default Notification
